import { render, staticRenderFns } from "./ResourceFiles.vue?vue&type=template&id=44d8aeaa&scoped=true&"
import script from "./ResourceFiles.vue?vue&type=script&lang=js&"
export * from "./ResourceFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d8aeaa",
  null
  
)

export default component.exports